import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Footer.scss";
import facebook from "../images/redes/Caralibro.svg";
import Instagram from "../images/redes/Instagram.svg";
import appStore from "../images/App.svg";
import logo from "../images/logoFooter.png";

const Footer = () => {
  return (
    <footer id="contacto">
      <div className="containerFooter">
        <div className="column1">
          <a href="./index.php">
            <img src={logo} alt="Logo Recubrimiento Epoxico de Mexicali" />
          </a>
          <div className="containerTextColumn1">
            <p>
            En Recubrimiento Epóxico de Mexicali, somos expertos en recubrimientos epóxicos. Ofrecemos soluciones duraderas y estéticas para pisos, encimeras y paredes, garantizando calidad y satisfacción en cada proyecto residencial.
            </p>
          </div>
        </div>

        <div className="column2">
          <div>
            <p>NOSOTROS</p>
            <div className="textColumn2">
              <a href="#inicio">
                <span>Conócenos</span>
              </a>
              <br />
              <a href="#porqueE">
                <span>¿Porque elegirnos?</span>
              </a>
              <br />
            </div>
          </div>
          <br />
          <div>
            <p>DATOS DE CONTACTO</p>
            <div className="textColumn2">
              <a href="mailto:info@recubrimientoepoxicomexicali.com">
                <span>Envíanos un email</span>
              </a>
              <br />
              <a href="tel:+5216866054231">
                <span>6866054231</span>
              </a>
            </div>
          </div>
        </div>

        <div className="column3">
          <div>
            <p>SERVICIOS</p>
            <div className="textColumn3">
              <a href="#servicio1">
                <span>Pisos Epoxicos</span>
              </a>
              <br />
              <a href="#servicio3">
                <span>Restauración y Mantenimiento</span>
              </a>
              <br />
              <br />
              <span className="ubicacionTitle">PROYECTOS</span>
              <br />
              <a href="https://wa.me/5216866054231" target="blank">
                <span id="ubicacion">
                Cotiza ahora
                </span>
              </a>
              <br />
            </div>
          </div>
        </div>

        <div className="column4">
          <div>
            <p>APPS</p>
            <div>
              <span>Proximamente</span>
            </div>
            <div className="containerImgApp">
              <img src={appStore} alt="" />
            </div>
          </div>

          <div className="containerRedes">
            <Fade cascade="true" direction="left">
              <a href="https://www.facebook.com/RecubrimientoEpoxicoMexicali/">
                <img src={facebook} alt="Facebook Recubrimiento Epoxico Mexicali" />
              </a>
            </Fade>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
